export default __webpack_public_path__ + "static/media/ic_avatar.47434bcc.svg";